export class VeteranStatus{
    hmy:number;
    veteran?:number;
    honorableDischarge?:number;
}